// TODO: Implement error boundary logic
const ReportErrorBoundary = () => {
  return <h2>Failed to load report. Please try again later.</h2>;
};

export default ReportErrorBoundary;
